import type { CustomerType } from '@origin-digital/sales-common';

export const getCesSignUpURL = (
  customerType: CustomerType,
  searchTerm?: string,
  isEspec = false,
  baseUrl?: string
): string => {
  const params = new URLSearchParams({ customerType });
  if (searchTerm) params.set('searchTerm', searchTerm);
  // Web-router serves these paths on the app origin. Separately hosted widgets can
  // supply the CES origin for their environment instead of navigating on their own host.
  const path = `${isEspec ? '/espec/ces' : '/ces'}?${params.toString()}`;
  return baseUrl ? new URL(path, baseUrl).toString() : path;
};
